import * as React from 'react'
import { Statistic } from 'antd'
import { useIntl } from 'react-intl'
import { useUnitInfo } from '../redux'

type Props = {
  unit: string
  amount: number
  renderTitle?: (_: { symbol: string }) => React.ReactNode
}

const Amount = ({ amount, renderTitle, unit }: Props) => {
  const unitInfo = useUnitInfo(unit)
  const intl = useIntl()

  return (
    <Statistic
      title={!!renderTitle ? renderTitle(unitInfo) : undefined}
      value={intl.formatNumber(amount / unitInfo.divider, {
        currency: unitInfo.symbol,
        style: 'currency',
        currencySign: 'standard',
        currencyDisplay: 'symbol',
        minimumFractionDigits: unitInfo.fractionDigits,
        maximumFractionDigits: unitInfo.fractionDigits,
      })}
    />
  )
}

export default Amount
